/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Базовый селект для выбора даты и времени доставки.
   */
  app.DeliveryPopupSelectView = app.View.extend({
    
    type: '',
    
    events: {
      'click li': 'select',
    },
    
    run: function () {
      this.render();
    },
    
    render: function () {
      this._initPopup();
    },
    
    _initPopup: function () {
      var that = this;
      this.popup = new als.Popup(this.$('.popup'), this.$('.js-popup-positioned-opener'), false, false, '.ui-icon');
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_OPEN,
        function () {
          var left = that.$('.js-popup-positioned-opener').position().left /*+ that.$('.js-popup-positioned-opener').outerWidth() / 2 - that.$('.popup').outerWidth() / 2*/,
            top = that.$('.js-popup-positioned-opener').position().top + that.$('.js-popup-positioned-opener').outerHeight() + 10;
          that.$('.js-popup-positioned-opener .with-icon_arrowdown-blue').addClass('with-icon_arrowup-blue').removeClass('with-icon_arrowdown-blue');
          that.$('.popup').css({
            top: top,
            left: left
          });
        }
      );
      this.popup.addEventListener(
        als.Popup.EventType.BEFORE_CLOSE,
        function () {
          that.$('.js-popup-positioned-opener .with-icon_arrowup-blue').addClass('with-icon_arrowdown-blue').removeClass('with-icon_arrowup-blue');
        }
      );
    },
    
    /**
     * Выбор модели
     * @param event
     */
    select: function (event) {
      var id = $(event.currentTarget).data('id'),
        model;
      if (id) {
        model = this.model.get(id);
        if (model && model instanceof app.Model) {
          this.trigger('select', model);
        }
        this.popup.close();
        return;
      }
      this.trigger('unselect', this.type);
      this.popup.close();
    }
  });
  
})(jQuery);

}.call(window));